import React, { useRef, useEffect, useState, useCallback } from "react";
import { Calendar } from "react-calendar";
import coverImg from "../../utils/cover-img.jpg";
import Address from "../address/Address";
import "./checkout.css";
import "react-calendar/dist/Calendar.css";
import api from "../../api/api";
import paytabs from "../../utils/Icons/ic_paytabs.svg";
import cod from "../../utils/ic_cod.svg";
import myfatoorahpng from "../../utils/paycard.png";

import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Link, Router, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import Modal from "react-bootstrap/Modal";
// import { Modal } from 'antd';

//lottie animation JSONs
import Lottie from "lottie-react";
import animate1 from "../../utils/order_placed_back_animation.json";
import animate2 from "../../utils/order_success_tick_animation.json";

//payment methods - only COD and Paytabs remain
import Loader from "../loader/Loader";
import Promo from "../cart/Promo";
import { useTranslation } from "react-i18next";
import {
  setCart,
  setCartCheckout,
  setCartProducts,
  setCartPromo,
  setCartSubTotal,
  setWallet,
} from "../../model/reducer/cartReducer";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { PiWallet } from "react-icons/pi";
import { deductUserBalance } from "../../model/reducer/authReducer";
import { ValidateNoInternet } from "../../utils/NoInternetValidator";
import { MdSignalWifiConnectedNoInternet0 } from "react-icons/md";
import { formatDate } from "../../utils/formatDate";
import { setPromoCode } from "../../model/reducer/promoReducer";
import { IoIosWarning } from "react-icons/io";
import Location from "../location/Location";

const Checkout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const city = useSelector((state) => state.city);
  const cart = useSelector((state) => state.cart);
  const address = useSelector((state) => state.address);
  const user = useSelector((state) => state.user);
  const setting = useSelector((state) => state.setting);
  const promoCode = useSelector((state) => state.promoCode);

  const [paymentUrl, setpaymentUrl] = useState(null);
  const [codAllow, setCodAllow] = useState(0);
  const [totalPayment, setTotalPayment] = useState(null);
  const [walletDeductionAmt, setWalletDeductionAmt] = useState(null);
  const [order, setOrder] = useState(false);
  const [walletAmount, setWalletAmount] = useState(user?.user?.balance);
  const [isPromoApplied, setIsPromoApplied] = useState(false);
  const [IsOrderPlaced, setIsOrderPlaced] = useState(false);
  const [expectedDate, setexpectedDate] = useState(null);
  const [timeslots, settimeslots] = useState(null);
  const [selectedAddress, setselectedAddress] = useState(null);
  const today = new Date();
  const [expectedTime, setexpectedTime] = useState();
  const [paymentMethod, setpaymentMethod] = useState("");
  const [deliveryTime, setDeliveryTime] = useState("");
  const [orderID, setOrderID] = useState(0);
  const [loadingPlaceOrder, setloadingPlaceOrder] = useState(false);
  const [show, setShow] = useState(false);
  const [showPromoOffcanvas, setShowPromoOffcanvas] = useState(false);
  const [isFullWalletPay, setIsFullWalletPay] = useState(false);
  const [isLoader, setisLoader] = useState(false);
  const [isNetworkError, setIsNetworkError] = useState(false);
  const [orderNote, setOrderNote] = useState("");
  const [cartError, setCartError] = useState("");
  const [locModal, setLocModal] = useState(false);
  const [bodyScroll, setBodyScroll] = useState(false);
  const [deliveryCharge, setDeliveryCharge] = useState(null);
  const isUpdatingFromFetchCart = useRef(false);
  const fetchCartTimeout = useRef(null);

  useEffect(() => {
    fetchCart();
    // console.log(cart.promo_code);
    let latitude;
    let longitude;
    const currentDate = new Date();
    setexpectedDate(currentDate);
    if (address.address !== null) {
      latitude = address?.selected_address?.latitude;
      longitude = address?.selected_address?.longitude;
    } else {
      latitude = city?.city?.latitude;
      longitude = city?.city?.longitude;
    }
    api
      .getCartSeller(user?.jwtToken, latitude, longitude, 1)
      .then((res) => res.json())
      .then((result) => {
        setCodAllow(result?.data?.cod_allowed);
        // setpaymentMethod("COD");
      })
      .catch((error) => console.log(error));
    fetchTimeSlot();
  }, []);

  useEffect(() => {
    fetchCart();
  }, [locModal]);

  const debouncedFetchCart = useCallback((latitude = null, longitude = null) => {
    if (fetchCartTimeout.current) {
      clearTimeout(fetchCartTimeout.current);
    }
    fetchCartTimeout.current = setTimeout(() => {
      fetchCart(latitude, longitude);
    }, 300); // تأخير 300ms
  }, []);

  const fetchCart = async (forceLatitude = null, forceLongitude = null) => {
    isUpdatingFromFetchCart.current = true;
    let latitude;
    let longitude;

    if (forceLatitude && forceLongitude) {
      latitude = forceLatitude;
      longitude = forceLongitude;
    } else if (address.address !== null) {
      latitude = address?.selected_address?.latitude;
      longitude = address?.selected_address?.longitude;
    } else {
      latitude = city?.city?.latitude;
      longitude = city?.city?.longitude;
    }
    
    api
      .getCart(user?.jwtToken, latitude, longitude, 1)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === 1) {
          setCodAllow(result?.data?.cod_allowed);
          dispatch(setCartCheckout({ data: result.data }));
          setDeliveryCharge(
            result?.data?.delivery_charge?.total_delivery_charge
          );
          dispatch(setWallet({ data: 0 }));

          // حساب المبلغ الإجمالي مع الخصومات
          let calculatedTotal = result.data.total_amount;
          
          if (promoCode?.isPromoCode === true) {
            calculatedTotal = result.data.total_amount - promoCode?.discount;
          } else if (cart?.promo_code) {
            dispatch(
              setPromoCode({
                code: cart.promo_code,
                discount: cart.promo_code.discount,
                isPromoCode: true,
              })
            );
            calculatedTotal = result.data.total_amount - cart?.promo_code?.discount;
          }
          
          // تطبيق wallet discount إذا كان مفعل
          if (cart?.is_wallet_checked && calculatedTotal > user?.user?.balance) {
            calculatedTotal = calculatedTotal - user?.user?.balance;
          } else if (cart?.is_wallet_checked && calculatedTotal <= user?.user?.balance) {
            calculatedTotal = 0;
          }
          
          setTotalPayment(calculatedTotal);
          setWalletAmount(user?.user?.balance);
          setCartError("");
          
          // تأخير إعادة تعيين المرجع لضمان عدم تداخل useEffect
          setTimeout(() => {
            isUpdatingFromFetchCart.current = false;
          }, 100);
        } else if (result.status === 0) {
          setCartError(result?.message);
          // استخدام total_amount من API بدلاً من totalPayment القديم
          const updatedTotalPayment = result.data.total_amount - deliveryCharge;
          setTotalPayment(updatedTotalPayment);
          setDeliveryCharge(0);
        }
      })
      .catch((error) => {
        const isNoInternet = ValidateNoInternet(error);
        if (isNoInternet) {
          setIsNetworkError(isNoInternet);
        }
      });
  };

  // تم دمج هذا المنطق في fetchCart

  // مراقبة تغيير العنوان المحدد وتحديث السلة
  useEffect(() => {
    if (address?.selected_address?.latitude && address?.selected_address?.longitude) {
      debouncedFetchCart();
    }
  }, [address?.selected_address?.latitude, address?.selected_address?.longitude, debouncedFetchCart]);

  // تم دمج منطق تحديث المبلغ الإجمالي في fetchCart
  const fetchTimeSlot = () => {
    api
      .fetchTimeSlot()
      .then((response) => response.json())
      .then((result) => {
        if (result.status === 1) {
          if (result?.data?.time_slots_is_enabled == "false") {
            // toast.error(t("timeslots_not_enabled"));
          }
          settimeslots(result.data);
          setexpectedTime(
            result?.data?.time_slots.filter((element) =>
              checkLastOrderTime(element?.last_order_time)
            )[0]
          );
        }
      })
      .catch((error) => console.log(error));
  };

  const formatDate = (date) => {
    const day = date.getDate().toString().padStart(2, "0"); // Pad day with 0 if needed
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Pad month with 0 if needed
    const year = date.getFullYear().toString().slice(-2); // Get last two digits of the year
    return `${day}-${month}-${year}`;
  };

  const checkLastOrderTime = (lastTime) => {
    const currentTime =
      expectedDate == "Invalid Date" ? new Date() : expectedDate;
    if (currentTime > new Date()) {
      return true;
    }
    const hours = lastTime.split(":")[0];
    const minutes = lastTime.split(":")[1];
    const seconds = lastTime.split(":")[2];
    const lastOrderTime = new Date();
    lastOrderTime.setHours(hours);
    lastOrderTime.setMinutes(minutes);
    lastOrderTime.setSeconds(seconds);
    return currentTime <= lastOrderTime;
  };

  // Filter the time slots based on last_order_time
  useEffect(() => {
    const currentDateTime = new Date();
    setexpectedDate(
      new Date(currentDateTime.setDate(currentDateTime.getDate()))
    );
  }, [timeslots]);

  useEffect(() => {
    setexpectedTime(
      timeslots?.time_slots.filter((element) =>
        checkLastOrderTime(element?.last_order_time)
      )[0]
    );
  }, [expectedDate]);

  const handleModal = () => {
    setLocModal(true);
    setBodyScroll(true);
  };



  useEffect(() => {
    // تجاهل التحديثات القادمة من fetchCart
    if (isUpdatingFromFetchCart.current) {
      return;
    }
    
    // فقط تحديث wallet logic، لا نعيد حساب totalPayment هنا
    if (cart?.is_wallet_checked && totalPayment > walletAmount) {
      setWalletDeductionAmt(walletAmount);
      setWalletAmount(0);
      setIsFullWalletPay(false);
    } else if (cart?.is_wallet_checked && totalPayment <= walletAmount) {
      const remainingwalletBalance = walletAmount - totalPayment;
      setWalletDeductionAmt(totalPayment);
      setWalletAmount(remainingwalletBalance);
      setIsFullWalletPay(true);
      setpaymentMethod("Wallet");
    } else if (!cart?.is_wallet_checked) {
      setWalletAmount(user.user.balance);
      setWalletDeductionAmt(0);
      setIsFullWalletPay(false);
    }
  }, [cart?.is_wallet_checked]); // إزالة totalPayment و walletAmount من dependencies

  const HandlePlaceOrder = async (e) => {
    // e.preventDefault();
    //place order
    if (!expectedDate) {
      toast.error(t("please_select_date"));
    } else if (!address.address) {
      toast.error(t("please_select_address"));
      // toast.error(t("something_went_wrong_select_address"));
    } else if (address.selected_address === null) {
      toast.error("Please Select a Default Delivery Address");
    } else {
      setDeliveryTime(
        `${expectedDate.getDate()}-${
          expectedDate.getMonth() + 1
        }-${expectedDate.getFullYear()} ${expectedTime?.title}`
      );
      const delivery_time = `${expectedDate.getDate()}-${
        expectedDate.getMonth() + 1
      }-${expectedDate.getFullYear()} ${expectedTime?.title}`;

      setloadingPlaceOrder(true);
      if (paymentMethod === "") {
        toast.error(t("please_select_payment_method"));
        setloadingPlaceOrder(false);
        return;
      }
      if (delivery_time === null) {
        toast.error("Please Select Preferred Delivery Time");
        setloadingPlaceOrder(false);
        return;
      } else if (paymentMethod === "COD") {
        // place order
        await api
          .placeOrder(
            user?.jwtToken,
            cart.checkout.product_variant_id,
            cart.checkout.quantity,
            cart.checkout.sub_total,
            cart.checkout.delivery_charge.total_delivery_charge,
            totalPayment,
            paymentMethod,
            address.selected_address.id,
            delivery_time,
            cart.promo_code?.promo_code_id,
            cart.is_wallet_checked ? walletDeductionAmt : null,
            cart.is_wallet_checked ? 1 : 0,
            orderNote
          )
          .then((response) => response.json())
          .then(async (result) => {
            setisLoader(false);
            if (result.status === 1) {
              setOrderNote("");
              toast.success("Order Successfully Placed!");
              setloadingPlaceOrder(false);
              dispatch(setWallet({ data: 0 }));
              dispatch(setCartPromo({ data: null }));
              dispatch(setCartProducts({ data: [] }));
              dispatch(setCartSubTotal({ data: 0 }));
              dispatch(deductUserBalance({ data: walletDeductionAmt }));
              setIsOrderPlaced(true);
              setShow(true);
            } else {
              toast.error(result.message);
              setloadingPlaceOrder(false);
              setOrderNote("");
            }
            dispatch(
              setPromoCode({
                code: null,
                discount: 0,
                isPromoCode: false,
              })
            );
          })
          .catch((error) => {
            setisLoader(false);
            setloadingPlaceOrder(false);
            console.log(error);
          });
      } else if (paymentMethod === "Wallet") {
        await api
          .placeOrder(
            user?.jwtToken,
            cart.checkout.product_variant_id,
            cart.checkout.quantity,
            cart.checkout.sub_total,
            cart.checkout.delivery_charge.total_delivery_charge,
            totalPayment,
            paymentMethod,
            address.selected_address.id,
            delivery_time,
            cart.promo_code?.promo_code_id,
            cart.is_wallet_checked ? walletDeductionAmt : null,
            cart.is_wallet_checked ? 1 : 0,
            orderNote
          )
          .then((response) => response.json())
          .then(async (result) => {
            setisLoader(false);
            if (result.status === 1) {
              setOrderNote("");
              toast.success("Order Successfully Placed!");
              setloadingPlaceOrder(false);
              dispatch(setWallet({ data: 0 }));
              dispatch(setCartPromo({ data: null }));
              dispatch(deductUserBalance({ data: walletDeductionAmt }));
              setIsOrderPlaced(true);
              setShow(true);
              dispatch(setCartProducts({ data: [] }));
              dispatch(setCartSubTotal({ data: 0 }));
            } else {
              toast.error(result.message);
              setloadingPlaceOrder(false);
              setOrderNote("");
              api.deleteOrder(user?.jwtToken, result.data.order_id);
            }
            dispatch(
              setPromoCode({
                code: null,
                discount: 0,
                isPromoCode: false,
              })
            );
          })
          .catch((error) => {
            setisLoader(false);
            setloadingPlaceOrder(false);
            console.log(error);
          });

        // else if (paymentMethod === "Paytm") {
        //      await api.placeOrder(user?.jwtToken, cart.checkout.product_variant_id, cart.checkout.quantity, cart.checkout.sub_total, cart.checkout.delivery_charge.total_delivery_charge, cart.promo_code ? cart.promo_code.discounted_amount: cart.checkout.total_amount, paymentMethod, address.selected_address.id, delivery_time)
        //         .then(response => response.json())
        //         .then(async result => {
        //             if (result.status === 1) {

        //             }

        //         })
        //         .catch(error => console.error(error))
        // }
      } else if (paymentMethod == "Paytabs") {
        await api
          .placeOrder(
            user?.jwtToken,
            cart.checkout.product_variant_id,
            cart.checkout.quantity,
            cart.checkout.sub_total,
            cart.checkout.delivery_charge.total_delivery_charge,
            totalPayment,
            paymentMethod,
            address.selected_address.id,
            delivery_time,
            cart.promo_code?.promo_code_id,
            cart.is_wallet_checked ? walletDeductionAmt : null,
            cart.is_wallet_checked ? 1 : 0,
            orderNote
          )
          .then((res) => res.json())
          .then(async (result) => {
            if (result.status === 1) {
              setOrderNote("");
              dispatch(setCartPromo({ data: null }));
              setloadingPlaceOrder(false);
              setOrderID(result.data.order_id);
              // يأخذ رقم الطلب عشان بوابة الدفع
              await api
                .initiate_transaction(
                  user?.jwtToken,
                  result?.data?.order_id,
                  "Paytabs",
                  "order"
                )
                .then((res) => res.json())
                .then((res) => {
                  if (res?.status === 1) {
                    setisLoader(false);
                    setloadingPlaceOrder(false);
                    setpaymentUrl(res.data?.redirectUrl);
                    dispatch(deductUserBalance({ data: walletDeductionAmt }));
                    dispatch(setCartPromo({ data: null }));
                    let subWindow = window.open(
                      res?.data?.redirectUrl,
                      "_parent"
                    );
                  } else {
                    toast.error(res.message);
                    setloadingPlaceOrder(false);
                    api.deleteOrder(user?.jwtToken, result.data.order_id);
                  }
                  dispatch(
                    setPromoCode({
                      code: null,
                      discount: 0,
                      isPromoCode: false,
                    })
                  );
                })
                .catch((err) => {
                  toast.error(err.message);
                  setisLoader(false);
                  setloadingPlaceOrder(false);
                });
            } else {
              toast.error(result.message);
              setloadingPlaceOrder(false);
              setOrderNote("");
            }
          });
      }
    }
  };
  const handleClose = () => {
    setisLoader(true);
    api
      .removeCart(user?.jwtToken)
      .then((response) => response.json())
      .then(async (result) => {
        if (result.status === 1) {
          dispatch(setCart({ data: null }));
          dispatch(setCartCheckout({ data: null }));
        }
      });
    setShow(false);
    navigate("/");
  };

  useEffect(() => {
    if (IsOrderPlaced) {
      setShow(true);
      setTimeout(async () => {
        handleClose();
      }, 5000);
    }
  }, [IsOrderPlaced]);

  const { t } = useTranslation();

  const placeHolderImage = (e) => {
    e.target.src = setting.setting?.web_logo;
  };
  const getEstimatedDeliveryDate = () => {
    const daysToAdd =
      parseInt(setting?.setting?.web_settings?.delivery_estimate_days) || 0;

    // Create a new date object for the current date
    const currentDate = new Date();

    // Add the specified number of days
    const deliveryDate = new Date(
      currentDate.setDate(currentDate.getDate() + daysToAdd)
    );
    return formatDate(deliveryDate);
  };
  const current = new Date();
  return (
    <>
      {!isNetworkError ? (
        <>
          <section id="checkout">
            {IsOrderPlaced ? (
              <>
                <Modal
                  show={show}
                  onHide={handleClose}
                  backdrop="static"
                  keyboard={true}
                  className="success_modal"
                  dialogClassName="successModalDialog"
                >
                  <Lottie
                    className="lottie-content"
                    animationData={animate1}
                    loop={true}
                  ></Lottie>
                  <Modal.Header
                    closeButton
                    className="flex-column-reverse success_header"
                  >
                    <Modal.Title>
                      <Lottie
                        animationData={animate2}
                        loop={false}
                        className="lottie-tick"
                      ></Lottie>
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body className="success_body d-flex flex-column justify-content-center align-items-center">
                    <div>
                      <p className="order-success-desc">
                        {t("order_placed_description")}
                      </p>
                    </div>
                    <button onClick={handleClose} className="checkout_btn">
                      {t("go_to_home")}
                    </button>
                  </Modal.Body>
                  {/* <Modal.Footer className="success_footer">

                            </Modal.Footer> */}
                </Modal>
              </>
            ) : null}

            <div className="cover">
              <img
                src={coverImg}
                onError={placeHolderImage}
                className="img-fluid"
                alt="cover"
              ></img>
              <div className="title">
                <h3>{t("checkout")}</h3>
                <span>
                  <Link to="/" className="text-white text-decoration-none">
                    {t("home")} /{" "}
                  </Link>{" "}
                </span>
                <span className="active">{t("checkout")}</span>
              </div>
            </div>

            {!setting.payment_setting === null && !expectedTime === null ? (
              <Loader screen="full" />
            ) : (
              <>
                <div className="checkout-container container">
                  <div className="checkout-util-container col-lg-9">
                    <div className="billibg-address-wrapper checkout-component">
                      <span className="heading">{t("billing_details")}</span>

                      <Address
                        setselectedAddress={setselectedAddress}
                        selectedAddress={selectedAddress}
                        onAddressChange={debouncedFetchCart}
                      />
                    </div>
                    {timeslots && timeslots.time_slots_is_enabled === "true" ? (
                      <>
                        <div className="delivery-day-wrapper checkout-component">
                          <span className="heading">{t("prefered_day")}</span>
                          <div className="d-flex justify-content-center p-3 calendarContainer">
                            <Calendar
                              value={
                                expectedDate.toString() === "Invalid Date"
                                  ? new Date()
                                  : expectedDate
                              }
                              onChange={(e) => {
                                if (new Date(e) >= new Date()) {
                                  setexpectedDate(new Date(e));
                                } else if (
                                  new Date(e).getDate() ===
                                    new Date().getDate() &&
                                  new Date(e).getMonth() ===
                                    new Date().getMonth() &&
                                  new Date(e).getFullYear() ===
                                    new Date().getFullYear()
                                ) {
                                  setexpectedDate(new Date(e));
                                } else {
                                  toast.info(
                                    "Please Select Valid Delivery Day"
                                  );
                                }
                              }}
                              calendarType={"gregory"}
                              className={"checkoutCalendar"}
                              minDate={
                                new Date(
                                  current.setDate(
                                    current.getDate() +
                                      (Number(
                                        timeslots?.time_slots_delivery_starts_from
                                      ) -
                                        1)
                                  )
                                )
                              }
                              maxDate={
                                new Date(
                                  current.setDate(
                                    current.getDate() +
                                      Number(
                                        timeslots?.time_slots_allowed_days - 1
                                      )
                                  )
                                )
                              }
                            />
                          </div>
                        </div>
                        <div className="delivery-time-wrapper checkout-component">
                          <span className="heading">{t("prefered_time")}</span>
                          <div
                            className="d-flex p-3"
                            style={{ flexWrap: "wrap" }}
                          >
                            {timeslots === null ? (
                              <Loader screen="full" />
                            ) : (
                              <>
                                {timeslots?.time_slots
                                  ?.filter((element) =>
                                    checkLastOrderTime(element?.last_order_time)
                                  )
                                  .map((timeslot, index) => {
                                    return (
                                      <div
                                        key={index}
                                        className="time-slot-container"
                                      >
                                        <div>
                                          <input
                                            type="radio"
                                            name="TimeSlotRadio"
                                            id={`TimeSlotRadioId${index}`}
                                            defaultChecked={
                                              index === 0 ? true : false
                                            }
                                            onChange={() => {
                                              setexpectedTime(timeslot);
                                            }}
                                          />
                                        </div>
                                        <div>{timeslot?.title}</div>
                                      </div>
                                    );
                                  })}
                              </>
                            )}
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="delivery-time-wrapper checkout-component">
                          <span className="heading">
                            {t("estimate_delivery_date")}
                          </span>
                          <div className="d-flex justify-content-start align-items-center estimateDeliveryDate">
                            <span>
                              {t("estimate_delivery_date")} :{" "}
                              {getEstimatedDeliveryDate()}
                            </span>
                          </div>
                        </div>
                      </>
                    )}
                  </div>

                  <div className="order-container">
                    {user?.user?.balance > 0 ? (
                      <div className="promo-section">
                        <div className="heading">
                          <span>{t("Wallet")}</span>
                        </div>
                        <div className="promo-wrapper">
                          <div className="promo-container">
                            <div className="d-flex justify-content-between align-items-center">
                              <div
                                className="image-container d-flex align-items-center"
                                style={{ gap: "15px" }}
                              >
                                <PiWallet
                                  size={35}
                                  fill={"var(--secondary-color)"}
                                />
                                <span style={{ fontSize: "14px" }}>
                                  {t("Wallet Balance")}
                                </span>
                                <p
                                  style={{
                                    color: "var(--secondary-color",
                                    fontSize: "14px",
                                  }}
                                  className="mb-0 me-2"
                                >
                                  {setting?.setting?.currency}
                                  {/* {t(parseFloat(user?.user?.balance).toFixed(setting?.setting && setting?.setting?.decimal_point))} */}

                                  {t(
                                    parseFloat(walletAmount).toFixed(
                                      setting?.setting &&
                                        setting?.setting?.decimal_point
                                    )
                                  )}
                                </p>
                              </div>
                              <div>
                                <input
                                  type="checkbox"
                                  disabled={IsOrderPlaced ? true : false}
                                  checked={
                                    cart.is_wallet_checked ? true : false
                                  }
                                  onClick={() => {
                                    cart.is_wallet_checked
                                      ? dispatch(setWallet({ data: 0 }))
                                      : dispatch(setWallet({ data: 1 }));
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null}

                    {isFullWalletPay ? (
                      <></>
                    ) : (
                      <div className="payment-wrapper checkout-component">
                        <span className="heading">{t("payment_method")}</span>
                        {setting?.payment_setting?.cod_payment_method === "1" &&
                        codAllow == 1 ? (
                          <label
                            className="form-check-label cursorPointer"
                            htmlFor="cod"
                          >
                            <div className="payment-selector">
                              <img src={cod} alt="cod" />
                              <div className="">
                                <span>{t("cash_on_delivery")}</span>
                              </div>
                              <input
                                type="radio"
                                name="payment-method"
                                id="cod"
                                onChange={() => {
                                  setpaymentMethod("COD");
                                }}
                              />
                            </div>
                          </label>
                        ) : null}




                        {setting?.payment_setting?.paytabs_payment_method ===
                        "1" ? (
                          <label
                            className="form-check-label cursorPointer"
                            htmlFor="paytabs"
                          >
                            <div className="payment-selector">
                              <img src={myfatoorahpng} alt="دفع الكتروني" />
                              <div className="">
                                <span>دفع الكتروني</span>
                              </div>
                              <input
                                type="radio"
                                name="payment-method"
                                id="paytabs"
                                onChange={() => {
                                  setpaymentMethod("Paytabs");
                                }}
                              />
                            </div>
                          </label>
                        ) : null}
                      </div>
                    )}

                    <div className="checkout-component order-instructions-wrapper">
                      <div className="heading">{t("order_note")}</div>
                      <div className="order-instruction-body">
                        <textarea
                          rows={4}
                          cols={5}
                          value={orderNote}
                          className="order-instructions-input"
                          placeholder={`${t("order_note_hint")}`}
                          onChange={(e) => setOrderNote(e.target.value)}
                          maxLength={191}
                        />
                      </div>
                    </div>

                    <div className="order-summary-wrapper checkout-component">
                      <div className="order-bill">
                        <div className="heading">{t("order_summary")}</div>
                        <div className="order-details">
                          {cart.checkout === null || user.user === null ? (
                            <Loader screen="full" />
                          ) : (
                            <div className="summary">
                              <div className="d-flex justify-content-between">
                                <span>{t("sub_total")}</span>
                                <div className="d-flex align-items-center">
                                  <span>
                                    {setting.setting &&
                                      setting.setting.currency}{" "}
                                    {cart?.checkout?.sub_total?.toFixed(
                                      setting.setting &&
                                        setting.setting.decimal_point
                                    )}
                                  </span>
                                </div>
                              </div>

                              <div className="d-flex justify-content-between">
                                <span>{t("delivery_charge")}</span>

                                <div className="d-flex align-items-center">
                                  {cartError === "" ? (
                                    <span>
                                      {setting.setting &&
                                        setting.setting.currency}{" "}
                                      {cart?.checkout?.delivery_charge?.total_delivery_charge?.toFixed(
                                        setting.setting &&
                                          setting.setting.decimal_point
                                      )}
                                    </span>
                                  ) : (
                                    deliveryCharge
                                  )}
                                </div>
                              </div>

                              {promoCode.code !== null && (
                                <>
                                  <div className="d-flex justify-content-between">
                                    <span>{t("discount")}</span>
                                    <div className="d-flex align-items-center">
                                      <span>
                                        -{" "}
                                        {setting.setting &&
                                          setting.setting.currency}{" "}
                                        {Number(promoCode.discount)?.toFixed(
                                          setting.setting &&
                                            setting.setting.decimal_point
                                        )}
                                      </span>
                                    </div>
                                  </div>
                                </>
                              )}
                              {walletDeductionAmt ? (
                                <>
                                  <div className="d-flex justify-content-between">
                                    <span>{t("Wallet")}</span>
                                    <div className="d-flex align-items-center">
                                      <span>
                                        -{" "}
                                        {setting.setting &&
                                          setting.setting.currency}{" "}
                                        {Number(walletDeductionAmt)?.toFixed(
                                          setting.setting &&
                                            setting.setting.decimal_point
                                        )}
                                      </span>
                                    </div>
                                  </div>
                                </>
                              ) : (
                                <></>
                              )}

                              <div className="d-flex justify-content-between total">
                                <span>{t("total")}</span>
                                <div
                                  className="d-flex align-items-center total-amount"
                                  style={{ color: "var(--secondary-color)" }}
                                >
                                  <span>
                                    {setting.setting &&
                                      setting.setting.currency}
                                    {Number(totalPayment)?.toFixed(
                                      setting.setting &&
                                        setting.setting.decimal_point
                                    )}
                                  </span>
                                </div>
                              </div>
                              {loadingPlaceOrder ? (
                                <Loader
                                  screen="full"
                                  background="none"
                                  content={
                                    "Your transaction is being processed.Please don't refresh the page."
                                  }
                                />
                              ) : cartError !== "" ? (
                                <div>
                                  <p className="checkout-warning-msg">
                                    <IoIosWarning size={20} />
                                    {cartError}
                                  </p>
                                </div>
                              ) : (
                                <>
                                  {(setting.payment_setting
                                    .cod_payment_method === "1" &&
                                    codAllow == "1") ||
                                  setting?.payment_setting
                                    ?.paytabs_payment_method === "1" ? (
                                    <div className="button-container">
                                      <motion.button
                                        whiletap={{ scale: 0.8 }}
                                        type="button"
                                        className="checkout"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          HandlePlaceOrder();
                                        }}
                                      >
                                        {t("place_order")}
                                      </motion.button>
                                    </div>
                                  ) : (
                                    <div className="button-container">
                                      <button
                                        type="button"
                                        className="checkout"
                                        disabled
                                      >
                                        {t("enable_payment_methods")}
                                      </button>
                                    </div>
                                  )}
                                </>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            <Promo show={showPromoOffcanvas} setShow={setShowPromoOffcanvas} />
          </section>
          {/* <Modal
                        className='location'
                        id="locationModal"
                        centered
                        open={locModal}
                        transitionName=''
                    >
                        <Location isLocationPresent={isLocationPresent} setisLocationPresent={setisLocationPresent}
                            showModal={locModal} setLocModal={setLocModal} bodyScroll={setBodyScroll} />
                    </Modal> */}
        </>
      ) : (
        <div className="d-flex flex-column justify-content-center align-items-center noInternetContainer">
          <MdSignalWifiConnectedNoInternet0 />
          <p>{t("no_internet_connection")}</p>
        </div>
      )}
    </>
  );
};

export default Checkout;
